// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__VydQp","rootSuccess":"CompleteLink_rootSuccess__bZYaN","rootFailure":"CompleteLink_rootFailure__1IcJC","isDisabled":"CompleteLink_isDisabled__1AkoI"};